<script>
import baseMixin from '@/mixins/baseMixin'
import BaseCheckboxListSkeleton from '../skeleton/base-checkbox-list-skeleton.vue'

export default {
  name: 'LocationCertRequirementsCheckboxList',
  components: { BaseCheckboxListSkeleton },
  mixins: [baseMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
    preselect: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    updated(selected) {
      this.$emit('updated', selected)
    },
  },
}
</script>

<template>
  <section id="create-booking-form__location-cert-requirements">
    <header>
      <h4 class="subtitle-1 mb-0">
        {{ $t('bookingCreate.formCertificationInputLabel') }}
      </h4>
      <p>
        {{ $t('bookingCreate.formCertificationInputHint') }}
      </p>
    </header>

    <BaseCheckboxListSkeleton v-if="loading" />
    <BaseCheckboxList
      v-else
      :items="items"
      :preselect="preselect"
      @updated="updated"
    />
  </section>
</template>
